import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import LINK from 'constants/link.const';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import { createConsultationForm } from '../consultationForms.action';
import { FORM_STATUS, FORM_TEMPLATES } from '../consultationForms.const';

import CN from './NewFormTemplateModal.module.scss';

export const NewFormTemplateModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();

  const handleSelectTemplate = (template) => {
    const isScratch = template.id === 'scratch';
    const formData = {
      name: isScratch ? '' : t(template.nameKey),
      status: FORM_STATUS.DRAFT,
      rules: '',
      questions: isScratch
        ? []
        : template.questions.map((q, i) => ({
            id: `q_new_${Date.now()}_${i}`,
            text: q.text,
            type: q.type,
            required: q.required,
            options: q.options || [],
          })),
    };

    const newForm = dispatch(createConsultationForm(formData));
    onClose();

    const path = linkTo({ pattern: LINK.settingsFormBuilder, params: { salonId, formId: newForm.id } });
    history.push(path);
  };

  return (
    <SalonModal tag="NewFormTemplateModal" isOpen={isOpen} shouldCloseOnOverlayClick shouldCloseOnEsc noFooter onClose={onClose} fullWidth mode="dark" customClass={CN.modalDialog}>
      <SalonModal.Header>
        <div data-bem="NewFormTemplateModal__header" className={cn(CN.modalHeader, { [CN.darkMode]: isDarkMode })}>
          <Button variant="icon" tag="NewFormTemplateModal__close" className={CN.closeButton} onClick={onClose}>
            <Icon variant="closeDark" width="lg" />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={cn(CN.heading, { [CN.darkMode]: isDarkMode })}>
          <h2 className={CN.title}>{t('consultationForms.templateModal.title')}</h2>
          <p className={CN.subtitle}>{t('consultationForms.templateModal.subtitle')}</p>
        </div>
        <ul data-bem="NewFormTemplateModal__list" className={cn(CN.templateList, { [CN.darkMode]: isDarkMode })}>
          {FORM_TEMPLATES.map((template) => (
            <li key={template.id}>
              <button data-bem="NewFormTemplateModal__row" type="button" className={cn(CN.templateRow, { [CN.darkMode]: isDarkMode })} onClick={() => handleSelectTemplate(template)}>
                <span className={CN.iconWrap}>{template.icon}</span>
                <span className={CN.info}>
                  <span className={CN.topLine}>
                    <span className={CN.name}>{t(template.nameKey)}</span>
                    {template.questionCount > 0 && <span className={CN.questionsBadge}>{t('consultationForms.questionsCount', { count: template.questionCount })}</span>}
                  </span>
                  <span className={CN.subtext}>{t(template.subtitleKey)}</span>
                </span>
                <Icon variant="arrowNext" width="lg" />
              </button>
            </li>
          ))}
        </ul>
      </SalonModal.Body>
    </SalonModal>
  );
};
